<ion-list lines="true">
  <ion-item (click)="openRecordingMenu()" button="true" lines="none">
    <ion-icon src="/assets/icons/24px/chevron-left.svg" slot="start"> </ion-icon>
    <ion-label> Back </ion-label>
  </ion-item>

  <ion-item (click)="copy(mp4DownloadLink)" [disabled]="!mp4DownloadLink" button="true" lines="none">
    <ion-icon src="/assets/icons/24px/link.svg" slot="start"> </ion-icon>

    <ion-label>
      Copy Mp4 Link

      <p>Audio + Video</p>
    </ion-label>
  </ion-item>

  <ion-item (click)="copy(webmDownloadLink)" *ngIf="webmDownloadLink" button="true" lines="none">
    <ion-icon src="/assets/icons/24px/link.svg" slot="start"> </ion-icon>

    <ion-label>
      Copy Webm Link

      <p>Video Only</p>
    </ion-label>
  </ion-item>

  <ion-item
    (click)="copy(wavDownloadLink)"
    [disabled]="!wavDownloadLink"
    *ngIf="!recording.screenRecording"
    button="true"
    lines="none">
    <ion-icon src="/assets/icons/24px/link.svg" slot="start"> </ion-icon>

    <ion-label>
      Copy Wav Link

      <p>Audio Only</p>
    </ion-label>
  </ion-item>

  <ion-item
    (click)="copy(mp3DownloadLink)"
    [disabled]="!mp3DownloadLink"
    *ngIf="!recording.screenRecording"
    button="true"
    lines="none">
    <ion-icon src="/assets/icons/24px/link.svg" slot="start"> </ion-icon>

    <ion-label>
      Copy Mp3 Link

      <p>Audio Only</p>
    </ion-label>
  </ion-item>
</ion-list>
